// extracted by mini-css-extract-plugin
export default {"sidebarContent":"sidebar_sidebarContent__aGpaM","menuToggle":"sidebar_menuToggle__086s-","toggleButton":"sidebar_toggleButton__biD00","divider":"sidebar_divider__yUAH3"};